import React from 'react'
import './about.css'
import { BsAwardFill } from 'react-icons/bs'
import { FaUsers } from 'react-icons/fa'
import { GiFiles } from 'react-icons/gi'
import { about } from '../../data'

const About = () => {
  return (
    <section id='about'>
      <h5>Get to Know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={about.image} alt="" aria-hidden="true" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className='about__card'>
              <BsAwardFill className='about__icon' />
              <h5>Experience</h5>
              <small>{about.experience}</small>
            </article>

            <article className='about__card'>
              <FaUsers className='about__icon' />
              <h5>Clients</h5>
              <small>{about.clients}</small>
            </article>

            <article className='about__card'>
              <GiFiles className='about__icon' />
              <h5>Projects</h5>
              <small>{about.projects}</small>
            </article>
          </div>
          <p>{about.description}</p>
          <a href="#contact" className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default About
